import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

import { Tooltip } from '@mui/material';


const Personnel = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Grid
        container
        spacing={2}
        sx={[
          { mb: (theme) => theme.spacing(2) },
          { mt: (theme) => theme.spacing(2) },
        ]}
        style={{
          gridTemplateColumns: "auto 1fr",
          minWidth: 'calc(100vh)',
          justifyContent: "space-between",
          justifyItems: "stretch"
        }}
      >
        <Grid size={{ xs: 8, md: 8, lg: 12, xl: 12 }}>
          <Grid
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ mb: 2 }}
          >
            <Typography component="h2" variant="h6">
              Personnel
            </Typography>
            <Grid display={'flex'} alignItems="center">
              <Tooltip title="Add New Project">
                <span>
            
                </span>
                {/* <IconButton>
                  <AddOutlinedIcon />
                </IconButton> */}
              </Tooltip>
              <Typography component="span" variant="body1">
                Component Menu |
              </Typography>
            </Grid>
          </Grid>
          <Skeleton variant="rectangular" height={310} />
        </Grid>
      </Grid>
      <Grid
      >
        <Typography component="h2" variant="h6">
          Personnel
        </Typography>
        <Skeleton variant="rectangular" height={310} />     
      </Grid>
      <Grid
        columns={6}
        sx={[
          { mb: (theme) => theme.spacing(2) },
          { mt: (theme) => theme.spacing(8) },
        ]}
      >
        <Typography component="h2" variant="h6">
          Personnel
        </Typography>
        <Skeleton variant="rectangular" height={310} />
      </Grid>
    </Box>
  );
};

export default Personnel;
